import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "download-photos" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "mt-1 text-center" }, " Download Photographs ", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-8 offset-2" }
const _hoisted_5 = {
  key: 0,
  class: "alert alert-success text-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "Photographs downloaded", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Check your downloads folder.", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "alert alert-danger text-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "Download Failed", -1)
const _hoisted_11 = {
  key: 0,
  class: "font-weight-bold"
}

import { ref, computed, onMounted, watch, inject } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

// Injected properties

export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadPhotos',
  setup(__props) {

const actProperty: any = inject('actProperty');

// VueX Store
const store = useStore();
const router = useRouter();
const route = useRoute();

// Props definition
const errorMessage = ref('');
const success = ref<boolean | null>(null);
const refId = ref('');

const addRequest = (id: string) => {
  store.commit('app/addRequest', id);
};

const removeRequest = (id: string) => {
  store.commit('app/removeRequest', id);
};

const generatePhotosAction = (ref: string): Promise<any> =>  store.dispatch('reports/generatePhotos', ref);

// Equivalent of "mounted" lifecycle hook
onMounted(async () => {
  refId.value = (route.params.ref as string);
  await generatePhotos();
});

// Methods
const generatePhotos = async () => {
  await addRequest('generatePhotos');

  generatePhotosAction(refId.value)
    .then((key: string) => actProperty.downloadAttachment(key))
    .then(() => {
      success.value = true;
    })
    .catch((err: any) => {
      actProperty.displayError(err);
      success.value = false;
    })
    .finally(() => {
      removeRequest('generatePhotos');
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (success.value === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
          : _createCommentVNode("", true),
        (success.value === false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              (errorMessage.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(errorMessage.value), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-danger",
                onClick: _withModifiers(generatePhotos, ["stop"])
              }, " Try again ")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})